import React from 'react';
import {motion} from 'framer-motion';

const Hero=()=> {
  const handleScrollToContact=()=> {
    const element=document.querySelector('#contact');
    if (element) element.scrollIntoView({behavior: 'smooth'});
  };

  return (
    <section className="pt-24 pb-16 px-4 sm:px-6 lg:px-8" style={{backgroundColor: '#F9F5F0'}}>
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8}}
              className="text-center mb-8"
            >
              <h1
                className="text-6xl md:text-8xl font-serif mb-4"
                style={{fontFamily: 'Libre Baskerville,serif',color: '#2C2C2C'}}
              >
                Yin <span className="text-4xl md:text-5xl" style={{color: '#2C2C2C'}}>und</span> Klang
              </h1>
              <p
                className="text-lg md:text-xl leading-relaxed max-w-lg mx-auto"
                style={{fontFamily: 'Lato,sans-serif',color: '#2C2C2C'}}
              >
                Zeit für dich.
              </p>
              <p
                className="text-base md:text-lg leading-relaxed max-w-lg mx-auto mt-4"
                style={{fontFamily: 'Lato,sans-serif',color: '#2C2C2C'}}
              >
                Tiefe Ruhe für deinen Körper. Klarheit für deinen Geist.
              </p>
            </motion.div>

            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.4}}
              className="text-center mb-8"
            >
              <p
                className="leading-relaxed mb-6"
                style={{fontFamily: 'Lato,sans-serif',color: '#2C2C2C'}}
              >
                Gönn dir Momente,in denen du nichts leisten musst.<br />
                Yin Yoga und Klangschalen führen dich sanft in tiefe Entspannung.
              </p>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
              {[
                {title: 'Yin Yoga',description: 'Sanfte Dehnungen – dein Körper findet Ruhe'},
                {title: 'Klang',description: 'Schwingungen,die tief entspannen und dein Nervensystem beruhigen'}
              ].map((feature,index)=> (
                <motion.div
                  key={feature.title}
                  initial={{opacity: 0,y: 30}}
                  animate={{opacity: 1,y: 0}}
                  transition={{duration: 0.6,delay: 0.6 + index * 0.2}}
                  whileHover={{scale: 1.02}}
                  className="p-6 rounded-2xl shadow-lg border"
                  style={{backgroundColor: '#FFFFFF',borderColor: '#E8E2DC'}}
                >
                  <h3
                    className="text-xl font-semibold mb-3 text-center"
                    style={{fontFamily: 'Lato,sans-serif',color: '#314C40'}}
                  >
                    {feature.title}
                  </h3>
                  <p
                    className="text-sm text-center leading-relaxed"
                    style={{fontFamily: 'Lato,sans-serif',color: '#2C2C2C'}}
                  >
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.8}}
              className="p-6 rounded-2xl border text-center mb-8"
              style={{backgroundColor: '#FFFFFF',borderColor: '#CBB8A9'}}
            >
              <h3
                className="text-xl font-semibold mb-4"
                style={{fontFamily: 'Lato,sans-serif',color: '#314C40'}}
              >
                Zwei Expertinnen – Vier Teilnehmende – Eine Erfahrung
              </h3>
              <div
                className="space-y-2"
                style={{fontFamily: 'Lato,sans-serif',color: '#2C2C2C'}}
              >
                <p>• Stress lässt nach,innere Ruhe kehrt zurück</p>
                <p>• Du schläfst besser und fühlst dich ausgeglichener</p>
                <p>• Tiefe Entspannung – ohne Druck oder Ziel</p>
              </div>
            </motion.div>

            <motion.button
              onClick={handleScrollToContact}
              initial={{opacity: 0,scale: 0.8}}
              animate={{opacity: 1,scale: 1}}
              transition={{duration: 0.6,delay: 1.2}}
              whileHover={{scale: 1.05}}
              whileTap={{scale: 0.95}}
              className="w-full px-8 py-4 rounded-full text-lg font-semibold transition-colors duration-200 shadow-lg"
              style={{fontFamily: 'Lato,sans-serif',backgroundColor: '#314C40',color: '#FFFFFF'}}
            >
              Jetzt Platz sichern
            </motion.button>
          </div>

          <motion.div
            initial={{opacity: 0,x: 50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8,delay: 0.3}}
            className="relative"
          >
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759850698155-blob"
              alt="Nadine und Marcella mit Klangschale in ruhigem Raum"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent rounded-2xl"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;